export const MISHTAH_COMPLETE_REASON_ID = 6

export interface ILikutReasonOption {
  id: number
  desc: string
}

export interface ILikutProblemReasons {
  num: number
  tag: string
  resons: ILikutReasonOption[]
}

export type TLikutProblemTag = 'notExistInAzmana' | 'moreThenNeed' | 'lessThenNeed'

export type TLikutReasonsMap = Record<TLikutProblemTag, ILikutProblemReasons>

/**
 * brodMigdal 678 (Logical_Value): true — the משטח קומפלט reason stays visible
 * (current behavior); false — it is removed from BOTH deviation cases
 * (moreThenNeed and lessThenNeed). notExistInAzmana is never touched.
 * With isVisible === true the input object is returned as is.
 */
export const filterMishtahCompleteReasons = (
  reasons: TLikutReasonsMap,
  isVisible: boolean,
): TLikutReasonsMap => {
  if (isVisible) return reasons
  const withoutMishtahComplete = (block: ILikutProblemReasons): ILikutProblemReasons => ({
    ...block,
    resons: block.resons.filter((reason) => reason.id !== MISHTAH_COMPLETE_REASON_ID),
  })
  return {
    ...reasons,
    moreThenNeed: withoutMishtahComplete(reasons.moreThenNeed),
    lessThenNeed: withoutMishtahComplete(reasons.lessThenNeed),
  }
}
